import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getDoc } from '../store/idbHandler';
import { Patient } from '../store/types/patient';
import { getEditPtMH, getGenieSetting } from '../store/selectors/session';
import { GlobalState } from '../store/reducers';
import { track } from '../tracking';
import AbhaNotLinkedPopover from './AbhaNotLinkedPopover';
import { notification } from 'antd';
import { requestAbhaCreation } from '../api/abha/request-abha';
import CreateABHAModalSDK from '../components/abha/CreateABHAModalSdk';

const LinkABHAV2: React.FC<{
    cId: string;
    patient?: Patient;
    isAbhaModalOpen: boolean;
    setIsAbhaModel: (isOpen: boolean) => void;
    showAbhaIdPrefix?: boolean;
    abhaIdCss?: string;
    className?: string;
    classNameInner?: string;
    classNameInnerNotLinked?: string;
    onAbhaLink: (pt: Patient) => void;
}> = ({
    cId,
    patient,
    isAbhaModalOpen,
    setIsAbhaModel,
    showAbhaIdPrefix,
    abhaIdCss,
    className,
    classNameInner,
    classNameInnerNotLinked,
    onAbhaLink,
}) => {
    const isAbdm = useSelector((state: GlobalState) => getGenieSetting(state, 'abdm'));
    const doc = getDoc();
    const docId = doc?._id;
    const docName = [doc?.profile.personal.name.f, doc?.profile.personal.name.l]
        .filter(Boolean)
        .join(' ');
    const patientId = patient?.id;

    const patientNumber = patient?.personal?.phone?.n;

    const [open, setOpen] = useState(false);
    const [showAbhaLinkFlow, setShowAbhaLinkFlow] = useState<boolean | undefined>();

    const ptMH = useSelector((state: GlobalState) => getEditPtMH(state));

    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    // if (!isAbdm) {
    //     return null;
    // }

    const openLinkAbhaModel = () => {
        track('LINK_ABHA_CLICK', {
            clinic_id: cId,
            doc_id: docId,
            doc_name: docName,
        });

        hide();

        track('ABHA_LINK_SELECTED');

        if (!patient?.personal.age?.dob) {
            track('ABHA_LINK_DISMISSED', { reason: 'no-age' });
            showAbhaLinkFlow && setShowAbhaLinkFlow(false);
            notification.error({
                message: 'Age or DOB is required for ABHA creation',
                duration: 5,
            });
        } else {
            track('ABHA_LINK_TRIGGERED');
            setShowAbhaLinkFlow(true);
        }
    };

    const requestAbha = () => {
        if (patient?.id) {
            track('REQUEST_ABHA_CLICKED', { from: 'popup' });

            requestAbhaCreation(
                patient.id,
                () => {
                    hide();
                    notification.success({
                        message: 'ABHA creation request sent successfully!',
                        duration: 5,
                    });
                },
                () => {
                    hide();
                    notification.error({
                        message: 'Something went wrong!',
                        duration: 5,
                    });
                },
            );
        } else {
            track('REQUEST_ABHA_DISMISSED', { ptId: patient?.id, from: 'popup' });
        }
    };

    return (
        <div className={className ? className : ''}>
            {/* {patientAbha && !isEmpty(patientAbha) ? (
                <AbhaLinkedPopover
                    handleOpenChange={handleOpenChange}
                    open={open}
                    patient={patient}
                    className={classNameInnerNotLinked}
                    cId={cId}
                />
            ) : ( */}
            <AbhaNotLinkedPopover
                patient={patient}
                open={open}
                handleOpenChange={handleOpenChange}
                openLinkAbhaModel={openLinkAbhaModel}
                className={classNameInner}
                requestAbha={requestAbha}
                cId={cId}
                atLeastOneAbhaLinked={patient?.abhaV2?.length || patient?.abha ? true : false}
            />
            {/* )} */}

            {showAbhaLinkFlow && patient && (
                <CreateABHAModalSDK
                    onClose={() => setShowAbhaLinkFlow(undefined)}
                    oid={patient.localId}
                    mobile={patient.personal?.phone?.n}
                    onComplete={() => onAbhaLink(patient)}
                    method={'create_abha_with_mobile'}
                />
            )}
        </div>
    );
};

export default LinkABHAV2;
